Pegasus.Accordion = Ember.ContainerView.extend({
  classNames: [],
  childViews: ['heading', 'body'],
  isOpenBinding: 'parentView.isOpen',
  classNameBindings: ['isOpen:drawer-open'],
  headerText: null,

  isClosed: function() {
    return !this.get('isOpen');
  }.property('isOpen'),

  didInsertElement: function() {
    this._super();
    this.headerText = this.$('.accordion-heading a.accordion-toggle').html();
  },

  willDestroyElement: function(){
    this.set('isOpen', false);
    this._super();
  },

  heading: Ember.ContainerView.extend({
    classNames: ['heading'],
    childViews: ['head'],
    isOpenBinding: 'parentView.isOpen',
    classNameBindings: ['isOpen:drawer-open:drawer-closed'],

    head: Ember.View.extend({
      tagName: 'a',
      isOpenBinding: 'parentView.isOpen',
      classNameBindings: ['isOpen:drawer-open:drawer-closed'],
      isClosedBinding: 'parentView.parentView.isClosed',
      templateBinding: 'parentView.parentView.headTemplate',
      classNames: ['toggle'],
      accordionParentBinding: 'parentView.parentView.parentView',

      click: function(){
        this.set( 'accordionParent.activeAccordion', this.get('parentView.parentView') );
      }
    })
  }),

  body: Ember.ContainerView.extend({
    classNames: ['body'],
    isOpenBinding: 'parentView.isOpen',
    classNameBindings: ['isOpen:drawer-open:drawer-closed'],
    childViews: ['inner'],

    inner: Ember.View.extend({
      classNames: ['inner'],
      templateBinding: 'parentView.parentView.bodyTemplate',
      accordionParentBinding: 'parentView.parentView.parentView'
    })
  })
});

Pegasus.Accordion.showAll = function() {
  var $collapsable = $('.accordion-group .collapse');
  $collapsable.trigger('show');
  $collapsable.trigger('shown');
};

Handlebars.registerHelper('EditorAccordion', function(options) {
  options.hash.headTemplate = options.fn;
  options.hash.bodyTemplate = options.inverse;
  delete options.fn;
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.Accordion, options);
});
